import { render, staticRenderFns } from "./addnew.vue?vue&type=template&id=1ce63fff&scoped=true&"
import script from "./addnew.vue?vue&type=script&lang=js&"
export * from "./addnew.vue?vue&type=script&lang=js&"
import style0 from "./addnew.vue?vue&type=style&index=0&id=1ce63fff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce63fff",
  null
  
)

export default component.exports